export const getBackendPath = (path: string) => {
  const backendBaseUrl = import.meta.env.VITE_DIGITAL_PORTAL_BACKEND_BASE_URL;
  if (!backendBaseUrl) return path;

  return `${backendBaseUrl}${path}`;
};
